export const patchRevisionContent = (base, patch) => ({
  brief: patch?.brief ?? base?.brief ?? {},
  datas: patch?.datas ?? base?.datas ?? [],
  processes: patch?.processes ?? base?.processes ?? [],
  views: patch?.views ?? base?.views ?? [],
  proposals: patch?.proposals ?? base?.proposals,
  interactions: patch?.interactions ?? base?.interactions,
});

export const getLastSubmissionInteraction = (interactions) => {
  for (let index = interactions.length - 1; index >= 0; index -= 1) {
    const interaction = interactions[index];

    if (interaction.type === "SUBMISSION") {
      return interaction;
    }
  }

  return null;
};

export const preprocessContent = (content) => {

  if (!content) 
    return null;

  const defaultTabs = [];
  const proposals = content.proposals || [];
  const brief = content.brief || {};
  const datas = content.datas || [];
  const processes = content.processes || [];
  const views = content.views || [];
  const data = datas[0] || {};
  const process = processes[0] || {};
  const view = views[0] || {};
  const interactions = content.interactions || [];

  const getTabs = (proposalTabs) => {
    const tabs = JSON.parse(JSON.stringify(proposalTabs || []));
    for (const defaultTab of defaultTabs) {
      const found = tabs.find((t) => defaultTab.name.includes(t.name));
      if (!found)
        tabs.push({ ...defaultTab, content: "", is_placeholder: true });
    }
    return tabs;
  }

  return {
    ...content,
    brief,
    datas,
    processes,
    views,
    data,
    process,
    view,
    interactions,
    proposals: proposals.map((proposal) => ({
      ...proposal,
      context: proposal.context || {},
      additional_comments: proposal.additional_comments || "",
      content: (proposal.content || []).map((section) => ({
        ...section,
        tabs: getTabs(section.tabs),
      })),
    })),
  }

}

export const sanitizeProposalSections = (sections) => {
  return (sections || []).map((section) => ({
    ...section,
    tabs: (section.tabs || [])
      .filter((tab) => {
        if (!tab?.is_placeholder)
          return true;
        if ((tab.content || "").trim())
          return true;
        if ((tab.attachments || []).length > 0)
          return true;
        return false;
      })
      .map((tab) => {
        const nextTab = { ...tab };
        delete nextTab.is_placeholder;
        return nextTab;
      }),
  }));

}
